import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConstantsService } from './api-constants.service';
import { ImportTask } from '~core/models/import-task';
import { OffsetPagination, RequestParams } from '~core/models/core.models';

@Injectable()
export class ImportTaskService {
  private _http = inject(HttpClient);
  private _apiConstantsService = inject(ApiConstantsService);

  list(
    params?: RequestParams & {
      [key: string]: any;
    }
  ): Observable<OffsetPagination<ImportTask>> {
    return this._http.get<OffsetPagination<ImportTask>>(
      this._apiConstantsService.importTaskUrl,
      {
        params: {
          ...params,
          sort: params?.sort || 'issuedAt',
          desc: params?.desc || 'issuedAt'
        } as Record<string, any>
      }
    );
  }

  exportResultTasks(id: string): Observable<unknown> {
    return this._http.get(
      `${this._apiConstantsService.importTaskUrl}/${id}/export-result-tasks`,
      {
        responseType: 'arraybuffer',
        observe: 'response'
      }
    );
  }
}
